import React, { useEffect, useState } from "react";
import {
  Col,
  Divider,
  Form,
  Input,
  notification,
  Row,
  Select,
  Spin,
} from "antd";

import { LoadingOutlined } from "@ant-design/icons";

import WebUtils from "../../utils/WebUtils";
import countryCodes from "../../utils/CountryCodes.json";
import Utils from "../../utils/Utils";
import { profilePostApi } from "../../api/candidate";
import Loader from "../Loader";

const userDetail = Utils.getUserDetail();
function Profile({ data, updateData }) {
  const [countryCode, setCountryCode] = useState(data?.countryCode);

  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [form] = Form.useForm();

  const handleCancel = (e) => {
    e.preventDefault();
    setEdit(false);
    form.setFields([
      { name: "firstname", errors: [] },
      { name: "lastName", errors: [] },
      { name: "email", errors: [] },
      { name: "alternateEmail", errors: [] },
      { name: "phoneNumber", errors: [] },
    ]); // Clear all fields and validation messages
  };

  const handleSubmit = (value) => {
    const url = `${profilePostApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;
    setLoading(true);
    // console.log(value);
    let reqBody = {
      firstName: value.firstName,
      lastName: value.lastName,
      mobileNumber: value.phoneNumber,
      countryCode: countryCode,
    };
    // console.log(reqBody);
    WebUtils.httpOperations(url, reqBody, "POST")
      .then((result) => {
        // console.log(result);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          // console.log(result);
          updateData(reqBody);
          localStorage.setItem("userData", JSON.stringify(reqBody));
          notification.success({
            message: "Profile details updated successfully",
            placement: "topRight",
            showProgress: true,
          });
          // form.resetFields();
          form.setFields([
            { name: "firstname", errors: [] },
            { name: "lastName", errors: [] },
            { name: "email", errors: [] },
            { name: "alternateEmail", errors: [] },
            { name: "phoneNumber", errors: [] },
          ]);
          setLoading(false);
          setEdit(false);
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "failure"
        ) {
          setLoading(false);
          notification.warning({
            message: "Password change failed",
            placement: "topRight",
            showProgress: true,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleChange = (value) => {
    const el = document.querySelector(".ant-select-selection-item");
    if (el) {
      document.querySelector(".ant-select-selection-item").innerHTML = value;
    }
    setCountryCode(value);
  };

  useEffect(() => {
    const el = document.querySelector(".ant-select-selection-item");
    if (el) {
      document.querySelector(".ant-select-selection-item").innerHTML =
        countryCode;
    }
  }, []);

  const selectBefore = (
    <Select
      style={{ border: "none" }}
      defaultValue={countryCode}
      showSearch
      onChange={handleChange}
      disabled={!edit}
      // value={""}
      // className="p-0 m-0"
      className="custom-number-input"
      // placeholder="Select a country"
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children[0].toLowerCase().includes(input.toLowerCase()) ||
        option.children[2].toLowerCase().includes(input.toLowerCase())
      }
      dropdownStyle={{ width: "300px" }}
    >
      {countryCodes.map((country) => (
        <option key={country.name} value={country.code}>
          {country.name} ({country.code})
          {/* {renderOptionLabel(country.code)} */}
        </option>
      ))}
    </Select>
  );
  const handleKeyPress = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow only numbers
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };
  return (
    <>
      {loading && <Loader />}
      <div>
        <div className="w-full lg:w-[78%] xl:w-[82%] pt-[.75rem] ">
          <div>
            <p className="text-[#101828] font-semibold text-[1.25rem]">
              Profile
            </p>
            <p className="text-[#475467] w-full lg:w-[80%] text-[0.875rem]">
              Update your personal details here.
            </p>
          </div>
          <Divider />
          {data?.firstName && (
            <Form
              form={form}
              onFinish={handleSubmit}
              initialValues={{
                firstName: data?.firstName || "",
                lastName: data?.lastName || "",
                email: data?.email || "",
                phoneNumber: data?.mobileNumber || "",
              }}
            >
              <Row className="mt-6 gap-y-2">
                <Col className="w-full lg:w-[33%]">
                  <div className="text-[#475467] font-semibold text-[0.95rem]">
                    First Name <span className="text-[#206DC5]">*</span>
                  </div>
                </Col>
                <Col className="space-y-3 w-full lg:w-[50%]">
                  <Form.Item
                    name="firstName"
                    className="p-0 m-0"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the first name!",
                      },
                    ]}
                  >
                    <Input
                      className="w-full"
                      placeholder="First Name"
                      disabled={!edit}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row className="mt-4 gap-y-2">
                <Col className="w-full lg:w-[33%]">
                  <div className="text-[#475467] font-semibold text-[0.95rem]">
                    Last Name <span className="text-[#206DC5]">*</span>
                  </div>
                </Col>
                <Col className="space-y-3 w-full lg:w-[50%]">
                  <Form.Item
                    name="lastName"
                    className="p-0 m-0"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the last name!",
                      },
                    ]}
                  >
                    <Input
                      className="w-full"
                      placeholder="Last Name"
                      disabled={!edit}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row className="mt-4 gap-y-2">
                <Col className="w-full lg:w-[33%]">
                  <div className="text-[#475467] font-semibold text-[0.95rem]">
                    Email <span className="text-[#206DC5]">*</span>
                  </div>
                </Col>
                <Col className="space-y-3 w-full lg:w-[50%]">
                  <Form.Item
                    name="email"
                    className="p-0 m-0"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Email!",
                      },
                    ]}
                  >
                    <Input className="w-full" placeholder="email" disabled />
                  </Form.Item>
                </Col>
              </Row>
              {/* <Row className="mt-4 gap-y-2">
              <Col className="w-full lg:w-[33%]">
                <div className="text-[#475467] font-semibold text-[0.95rem]">
                  Alternative contact email
                </div>
                <div className="text-[#475467] text-[0.8rem] w-[80%]">
                  Enter an alternative email if you’d like to be contacted via a
                  different email.
                </div>
              </Col>
              <Col className="space-y-3 w-full lg:w-[50%]">
                <Form.Item name="alternateEmail" className="p-0 m-0">
                  <Input
                    className="w-full"
                    placeholder="alternate email"
                    disabled={!edit}
                  />
                </Form.Item>
              </Col>
            </Row> */}
              <Row className="mt-4 gap-y-2">
                <Col className="w-full lg:w-[33%]">
                  <div className="text-[#475467] font-semibold text-[0.95rem]">
                    Mobile number <span className="text-[#206DC5]">*</span>
                  </div>
                </Col>
                <Col className="space-y-3 w-full lg:w-[50%]">
                  <Form.Item
                    name="phoneNumber"
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: "Please enter your phone number!",
                      },
                    ]}
                  >
                    <Input
                      addonBefore={selectBefore}
                      placeholder="7********"
                      disabled={!edit}
                      onKeyPress={handleKeyPress}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row className="mt-5 gap-y-2">
                <Col className="w-full flex flex-col-reverse md:flex-row justify-end gap-2">
                  {!edit ? (
                    <button
                      type="primary"
                      className="text-[0.85rem] w-full md:w-[110px] btn-orange py-[7px] px-3 text-white rounded-lg shadow-sm"
                      onClick={(e) => {
                        setEdit(true);
                        e.preventDefault();
                      }}
                    >
                      Edit
                    </button>
                  ) : (
                    <>
                      <button
                        type="primary"
                        className="text-[0.85rem] w-full md:w-[110px] btn-orange py-[7px] px-3 text-white rounded-lg shadow-sm"
                        htmlType="submit"
                      >
                        Update
                      </button>
                      <button
                        type="default"
                        className="text-[0.85rem] w-full md:w-[110px] bg-white border border-[#D0D5DD] py-[7px] px-3 text-[#344054] rounded-lg shadow-sm"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                    </>
                  )}
                </Col>
              </Row>
              <Divider />
            </Form>
          )}
        </div>
      </div>
    </>
  );
}

export default Profile;
